define([
    'underscore',
    'jQuery',
    'library/fcse-binding/binding',
    'library/fcse-compatibility/object'],
    function (_, $, Binding, Object) {
        var SinglePropertyBinding = function (scopeProperty) {
            Binding.call(this);
            this.scopeProperty = scopeProperty;
        };
        SinglePropertyBinding.prototype = $.extend(Object.create(Binding), {
            fromScope: function (scope) {
                return scope[this.scopeProperty];
            },
            toScope: function (widgetValue) {
                var scopeValues = {};
                scopeValues[this.scopeProperty] = widgetValue;
                return scopeValues;
            },
            isValueAffectedBy: function (scopeParamName) {
                return scopeParamName === this.scopeProperty;
            }
        });
        return SinglePropertyBinding;
    }
);


//////////////////
// WEBPACK FOOTER
// ./~/fcse-binding/singlePropertyBinding.js
// module id = 157
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23